import { render, staticRenderFns } from "./FacebookAuthButton.vue?vue&type=template&id=68a9b99a&scoped=true&"
import script from "./FacebookAuthButton.vue?vue&type=script&lang=ts&"
export * from "./FacebookAuthButton.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookAuthButton.vue?vue&type=style&index=0&id=68a9b99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a9b99a",
  null
  
)

export default component.exports